import { render, staticRenderFns } from "./OwnerInfoItem.vue?vue&type=template&id=1b1cab49&scoped=true&"
import script from "./OwnerInfoItem.vue?vue&type=script&lang=js&"
export * from "./OwnerInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInfoItem.vue?vue&type=style&index=0&id=1b1cab49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1cab49",
  null
  
)

export default component.exports